export default __webpack_public_path__ + "static/assets/med_pill_triangle_in_L0_solid_x_01_f.4a309cfd.png";